import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/ebox/importer/eboxImporterActions';

export default importerReducers(actions);
